import {
  ApiInternshipId,
  ApiJobId,
  ApiOrgId,
  ApiVolopId,
} from 'api/types/ApiTypedId';
import { LISTING_TYPE_URL_SEGMENT_MAP } from 'utils/constants/general/listingTypeUrlSegmentMap';
import { del } from 'utils/http/del';
import { getJson } from 'utils/http/getJson';
import { postJson } from 'utils/http/postJson';
import { titleCaseToCamelCase } from 'utils/string';

import { fetchEvent } from './orgDashboardApiEvent';
import { OrgDashboardApiInternship } from './types/OrgDashboardApiInternship';
import { OrgDashboardApiJob } from './types/OrgDashboardApiJob';
import { OrgDashboardApiListing } from './types/OrgDashboardApiListing';
import { OrgDashboardApiRepostedListing } from './types/OrgDashboardApiRepostedListing';
import { OrgDashboardApiVolop } from './types/OrgDashboardApiVolop';

export function fetchJob(
  orgId: ApiOrgId,
  listingId: ApiJobId,
): Promise<OrgDashboardApiJob> {
  return getJson<{ job: OrgDashboardApiJob }>(
    `/data/orgdashboard/${orgId}/jobs/${listingId}`,
  ).then((response) => response.job);
}

export function fetchInternship(
  orgId: ApiOrgId,
  listingId: ApiInternshipId,
): Promise<OrgDashboardApiInternship> {
  return getJson<{ internship: OrgDashboardApiInternship }>(
    `/data/orgdashboard/${orgId}/internships/${listingId}`,
  ).then((response) => response.internship);
}

export function fetchVolop(
  orgId: ApiOrgId,
  listingId: ApiVolopId,
): Promise<OrgDashboardApiVolop> {
  return getJson<{ volop: OrgDashboardApiVolop }>(
    `/data/orgdashboard/${orgId}/volops/${listingId}`,
  ).then((response) => response.volop);
}

// @TODO - If we decide to remove `listings`
// from the org dashboard in Redux, ideally
// we would handle each specific listing type
// in its own page, and delete this function
export function fetchListing(
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT',
  listingId: string,
) {
  switch (listingType) {
    case 'JOB':
      return fetchJob(orgId, listingId);
    case 'INTERNSHIP':
      return fetchInternship(orgId, listingId);
    case 'VOLOP':
      return fetchVolop(orgId, listingId);
    case 'EVENT':
      return fetchEvent(orgId, listingId);
  }
}

export function hideListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}): Promise<OrgDashboardApiListing> {
  return postJson(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}/hide`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function unhideListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}) {
  return postJson(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}/unhide`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function deleteListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}) {
  return del(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function fetchRepostedListings(
  orgId: string,
): Promise<OrgDashboardApiRepostedListing[]> {
  return getJson<{ listings: OrgDashboardApiRepostedListing[] }>(
    `/data/orgdashboard/${orgId}/published-reposts`,
  ).then(({ listings }) => listings);
}
